import { Check, Warning } from '@mui/icons-material'
import { Box, Button, FormControl, FormHelperText, TextField } from '@mui/material'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { resetConfig, saveConfigAsync, selectConfig } from './AdminSlice'

const AdminConfigEditor = () => {
  const { operation, key, mode } = useParams()
  const config = useAppSelector(selectConfig)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [configKey, setConfigKey] = useState<any>(config.key)
  const [configValue, setConfigValue] = useState<any>(config.value)
  const [configDescription, setConfigDescription] = useState<any>(config.description)

  return (<Box sx={{ textAlign: 'left' }}>
    {(operation === 'new' || operation === 'edit') && config.appConfigId >= 0 && <>
      <FormControl fullWidth={true} required={true} sx={{ marginBottom: 2 }}>
        <TextField id="ip-text-config-key" label="Config key" variant="outlined"
          name="config-key" type="email" autoComplete="email"
          defaultValue={configKey ?? ''} disabled={operation !== 'new'} onChange={(e: any) => setConfigKey(e.target.value)} />
        <FormHelperText id="helper-text-config-key">Key of the configuration, read-only</FormHelperText>
      </FormControl>

      <FormControl fullWidth={true} required={true} sx={{ marginBottom: 2 }}>
        <TextField id="ip-text-config-value" label="Config Value" variant="outlined"
          name="config-value" defaultValue={configValue ?? ''} onChange={(e: any) => setConfigValue(e.target.value)} />
        <FormHelperText id="helper-text-config-value">Value of the configuration</FormHelperText>
      </FormControl>

      <FormControl fullWidth={true} required={true} sx={{ marginBottom: 2 }}>
        <TextField id="ip-text-config-description" label="Config Description" variant="outlined"
          name="config-description" defaultValue={configDescription ?? ''} onChange={(e: any) => setConfigDescription(e.target.value)} />
        <FormHelperText id="helper-text-config-description">Description of the configuration</FormHelperText>
      </FormControl>


      <Button variant="outlined" endIcon={<Check />} sx={{ marginRight: 2 }} onClick={() => {
        dispatch(saveConfigAsync({
          config: {
            appConfigId: config.appConfigId,
            version: config.version,
            key: configKey,
            value: configValue,
            description: configDescription
          },
          mode: mode ? mode : 'regular'
        }))
        navigate({ 'pathname': `/admin/config/${mode}` })
      }}>Save</Button>

      <Button variant="outlined" endIcon={<Warning />} sx={{ marginRight: 2 }} onClick={() => {
        dispatch(resetConfig())
        navigate({ 'pathname': `/admin/config/${mode}` })
      }}>Cancel</Button>

    </>}
  </Box>)
}

export default AdminConfigEditor